<template>
  <div class="plv-ia-load-error">
    接口异常
  </div>
</template>

<script>
export default {
  name: 'LoadError'
};
</script>

<style scoped>
.plv-ia-load-error {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: rgb(124 123 123);
}
</style>
